import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function Machine() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [owners, setOwners] = useState([]);
    const [formData, setFormData] = useState({
        owner: "",
        category: "",
        machine_name: "",
        brand: "",
        model: "",
        registration_no: "",
        manufacturing_year: "",
        rent_amount: "",
        rent_unit: "HOUR",
        operator_available: false,
        availability: true,
        location: "",
        image: null,
        remarks: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });
    const rentUnitList = [{
        id: "HOUR", name: "Per Hour",
    }, {
        id: "DAY", name: "Per Day",
    }, {
        id: "ACRE", name: "Per Acre",
    },];
    useEffect(() => {
        getMachineCategory();
        getMachine();
        fetchOwners();
    }, []);
    // ===========================================
    // FETCH OWNERS
    // ===========================================
    const fetchOwners = async () => {
        try {
            const res = await axios.get(baseUrl + "land-owner/create/");
            setOwners(res.data);
        } catch (error) {
            console.log(error);
        }
    };
    const getMachineCategory = () => {
        axios
            .get(baseUrl + "machine-category/")
            .then((res) => {
                setCategoryList(res.data);
            });
    };
    const getMachine = () => {
        setLoading(true);
        axios
            .get(baseUrl + "machine/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load Machines.",
                });
            });
    };
    const handleChange = (e) => {
        const {name, value, type, checked, files} = e.target;
        if (type === "checkbox") {
            setFormData({
                ...formData, [name]: checked,
            });
        } else if (type === "file") {
            setFormData({
                ...formData, [name]: files[0],
            });
        } else {
            setFormData({
                ...formData, [name]: value,
            });
        }
    };
    const clearForm = () => {
        setFormData({
            category: "",
            machine_name: "",
            brand: "",
            model: "",
            registration_no: "",
            manufacturing_year: "",
            rent_amount: "",
            rent_unit: "HOUR",
            operator_available: false,
            availability: true,
            location: "",
            owner: "",
            image: null,
            remarks: "",
            status: 1,
            addedby: userName,
            ip_add: ipAddress,
        });
    };
    const saveMachine = () => {
        const data = new FormData();
        data.append("owner", formData.owner);
        data.append("category", formData.category);
        data.append("machine_name", formData.machine_name);
        data.append("brand", formData.brand);
        data.append("model", formData.model);
        data.append("registration_no", formData.registration_no);
        data.append("manufacturing_year", formData.manufacturing_year);
        data.append("rent_amount", formData.rent_amount);
        data.append("rent_unit", formData.rent_unit);
        data.append("operator_available", formData.operator_available);
        data.append("availability", formData.availability);
        data.append("location", formData.location);
        data.append("location", formData.location);
        if (formData.image) {
            data.append("image", formData.image);
        }
        data.append("remarks", formData.remarks);
        data.append("status", formData.status);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        axios
            .post(baseUrl + "machine/", data)
            .then(() => {
                Swal.fire({
                    icon: "success", title: "Success", text: "Machine saved successfully.",
                });
                clearForm();
                getMachine();
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to save Machine.",
                });
            });
    };
    const deleteMachine = (id) => {
        Swal.fire({
            title: "Delete Machine?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(baseUrl + `delete-machine/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success", title: "Deleted", text: "Machine deleted successfully.",
                        });
                        getMachine();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error", title: "Error", text: "Unable to delete Machine.",
                        });
                    });
            }
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "machine_name", headerName: "Machine", flex: 1,
    }, {
        field: "category_name",
        headerName: "Category",
        width: 180,
        renderCell: (params) => params.row.category?.name || ""
    }, {
        field: "owner_name", headerName: "Owner", width: 200, renderCell: (params) => params.row.owner?.name || ""
    }, {
        field: "brand", headerName: "Brand", width: 150,
    }, {
        field: "model", headerName: "Model", width: 150,
    }, {
        field: "rent_amount", headerName: "Rent", width: 120,
    }, {
        field: "rent_unit", headerName: "Unit", width: 120,
    }, {
        field: "availability", headerName: "Available", width: 110, renderCell: (params) => params.value ? "Yes" : "No",
    }, {
        field: "status",
        headerName: "Status",
        width: 100,
        renderCell: (params) => params.value === 1 ? "Active" : "Inactive",
    },
     {
            field: "action",
            headerName: "Action",
            width: 180,
            sortable: false,
            renderCell: (params) => (
                <>

                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteMachine(params.row.id)}
                    >
                        Delete
                    </button>

                </>
            )
        }
        ];
    return (<div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Machine Master
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">
                        <div className="col-md-4 mb-3">

                            <label className="form-label">

                                Land Owner

                            </label>

                            <select

                                className="form-select"

                                name="owner"

                                value={formData.owner}

                                onChange={handleChange}

                            >

                                <option value="">

                                    Select Owner

                                </option>

                                {owners.map(owner => (<option

                                        key={owner.id}

                                        value={owner.id}

                                    >

                                        {owner.name}

                                    </option>))}

                            </select>

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Category</label>

                            <select
                                className="form-select"
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select Category
                                </option>

                                {categoryList.map((item) => (<option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </option>))}

                            </select>

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Machine Name</label>

                            <input
                                type="text"
                                className="form-control"
                                name="machine_name"
                                value={formData.machine_name}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Brand</label>

                            <input
                                type="text"
                                className="form-control"
                                name="brand"
                                value={formData.brand}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Model</label>

                            <input
                                type="text"
                                className="form-control"
                                name="model"
                                value={formData.model}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Registration No</label>

                            <input
                                type="text"
                                className="form-control"
                                name="registration_no"
                                value={formData.registration_no}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Manufacturing Year</label>

                            <input
                                type="number"
                                className="form-control"
                                name="manufacturing_year"
                                value={formData.manufacturing_year}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Rent Amount</label>

                            <input
                                type="number"
                                className="form-control"
                                name="rent_amount"
                                value={formData.rent_amount}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Rent Unit</label>

                            <select
                                className="form-select"
                                name="rent_unit"
                                value={formData.rent_unit}
                                onChange={handleChange}
                            >
                                {rentUnitList.map((item) => (<option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </option>))}
                            </select>

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Location</label>

                            <input
                                type="text"
                                className="form-control"
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Image</label>

                            <input
                                type="file"
                                className="form-control"
                                name="image"
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3 d-flex align-items-center">

                            <div className="form-check mt-4">

                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="operator_available"
                                    checked={formData.operator_available}
                                    onChange={handleChange}
                                />

                                <label className="form-check-label">
                                    Operator Available
                                </label>

                            </div>

                        </div>

                        <div className="col-md-3 mb-3 d-flex align-items-center">

                            <div className="form-check mt-4">

                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="availability"
                                    checked={formData.availability}
                                    onChange={handleChange}
                                />

                                <label className="form-check-label">
                                    Available
                                </label>

                            </div>

                        </div>

                        <div className="col-md-12 mb-3">

                            <label>Remarks</label>

                            <textarea
                                className="form-control"
                                rows="3"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Status</label>

                            <select
                                className="form-select"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </select>

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveMachine}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Machine List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600, width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[10, 25, 50, 100,]}

                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>);
}
export default Machine;